import { DYNAMIC_FOOTNOTE_ATTRIBUTE } from "@vega-core/components/HtmlContent/DynamicFootnote";

export const htmlToPlainText = (html: string | null | undefined): string => {
  if (!html) return "";

  const doc = new DOMParser().parseFromString(html, "text/html");

  doc.body
    .querySelectorAll(`[${DYNAMIC_FOOTNOTE_ATTRIBUTE}]`)
    .forEach((footnote) => footnote.remove());
  doc.body.querySelectorAll("br").forEach((br) => br.replaceWith(" "));

  return doc.body.textContent.replace(/\s+/g, " ").trim();
};
